var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsAppHeaderFullColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 214,
    viewBox: "0 0 212 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_30_1595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3288 95.4609C27.3252 108.674 30.7767 121.575 37.3396 132.946L26.7012 171.799L66.4519 161.373C77.4464 167.36 89.765 170.497 102.283 170.498H102.316C143.641 170.498 177.28 136.862 177.298 95.52C177.306 75.4867 169.513 56.6486 155.355 42.4759C141.199 28.3044 122.372 20.4957 102.313 20.4866C60.9834 20.4866 27.3465 54.1203 27.3294 95.4609",
    fill: "url(#paint0_linear_30_1595)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.652 95.4365C24.6478 109.125 28.223 122.487 35.0199 134.266L24 174.511L65.1761 163.712C76.5214 169.899 89.2951 173.162 102.293 173.166H102.327C145.134 173.166 179.982 138.321 180 95.4987C180.007 74.7455 171.934 55.2302 157.27 40.5498C142.604 25.8711 123.104 17.7815 102.327 17.7729C59.5119 17.7729 24.6697 52.6135 24.6526 95.4365H24.652ZM49.1733 132.237L47.6358 129.796C41.1728 119.517 37.7615 107.639 37.7664 95.4414C37.7804 59.848 66.7403 30.89 102.351 30.89C119.596 30.8973 135.803 37.6216 147.993 49.8219C160.183 62.0234 166.89 78.2429 166.886 95.4938C166.87 131.087 137.909 160.049 102.327 160.049H102.301C90.715 160.043 79.352 156.93 69.4423 151.049L67.084 149.65L42.6493 156.058L49.1733 132.237V132.237Z",
    fill: "url(#paint1_linear_30_1595)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9132 62.9681C81.4592 59.7358 79.9291 59.6706 78.5464 59.6139C77.4142 59.5651 76.1199 59.5688 74.8268 59.5688C73.5325 59.5688 71.4295 60.0558 69.652 61.9971C67.8726 63.9403 62.8586 68.6361 62.8586 78.1868C62.8586 87.7381 69.8134 96.9682 70.783 98.2646C71.7537 99.5587 84.2093 119.785 103.936 127.566C120.331 134.033 123.667 132.747 127.225 132.423C130.784 132.099 138.708 127.728 140.325 123.195C141.943 118.662 141.943 114.777 141.458 113.965C140.973 113.157 139.678 112.671 137.737 111.7C135.796 110.729 126.254 106.033 124.476 105.385C122.696 104.738 121.403 104.415 120.108 106.359C118.814 108.299 115.097 112.671 113.964 113.965C112.833 115.263 111.7 115.425 109.76 114.454C107.818 113.48 101.567 111.432 94.1519 104.819C88.3823 99.6739 84.4872 93.3195 83.355 91.3758C82.2228 89.435 83.2337 88.383 84.2069 87.4157C85.0789 86.5459 86.1483 85.1488 87.1197 84.0157C88.0874 82.882 88.4103 82.0731 89.0575 80.7785C89.7053 79.4827 89.3811 78.3489 88.8966 77.378C88.4103 76.407 84.6389 66.8069 82.9132 62.9687",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_30_1595",
    x: 0,
    y: 0.772949,
    width: 212,
    height: 212.738,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_30_1595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_30_1595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_1595",
    x1: 102,
    y1: 171.799,
    x2: 102,
    y2: 20.4866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30_1595",
    x1: 102,
    y1: 174.511,
    x2: 102,
    y2: 17.7729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsAppHeaderFullColor);
export default __webpack_public_path__ + "static/media/whatsAppHeaderFullColor.63d58f981fbc86ec953a13f1a2044dbf.svg";
export { ForwardRef as ReactComponent };